import React from 'react'

import { Table, Chip } from '@arnsbogroup/react-voicearchive'
import { FormattedDate, FormattedTime } from 'react-intl'
import SearchPage from 'containers/SearchPage'
import { Span, Contact } from 'components/datatable'
import classNames from 'classnames'

const OrderSearchPage = ( { history, ...props } ) => {

    const OrderStage = ({ stage }) => (
        <Chip size="xs" state={{
            'PENDING': 'info',
            'IN_PROGRESS': 'info',
            'READY': 'success',
            'CLOSED': 'error',
            'AMENDING': 'warning',
        }[stage] ?? undefined}>
            <span className="capitalize">
                { stage ? stage.toLowerCase().replace('_', ' ') : '' }
            </span>
        </Chip>
    )

    const Deadline = ({ deadline }) => {
        const value = new Date(deadline * 1000)
        return (
            <div className="space-x-1">
                <span>
                    <FormattedDate value={value} />
                </span>
                <span>
                    <FormattedTime value={value} />
                </span>
            </div>
        )
    }

    const TasksSummary = ({ tasks = [] }) => {
        let suppliers = {}
        let types = {}

        tasks.map(({ type, supplier: { userid } }) => {
            types[type] = types[type] ? (types[type] + 1) : 1
            suppliers[userid] = userid
        })

        return (
            <div>
                <div className="text-sm">
                    { Object.entries(types).reduce((arr, [key, val]) => [...arr, `${key}${val}`], []).join(', ') }
                </div>
                <div className="text-xs truncate hover:text-clip hover:whitespace-wrap" title={Object.keys(suppliers).join('\n')}>
                    { Object.keys(suppliers).join(', ') }
                </div>
            </div>
        )
    }

    const Coordinator = ({ coordinator_email, coordinator_name, coordinator_image }) => (
        <Contact
            contact_name={coordinator_name || coordinator_email}
            contact_email={coordinator_email}
            contact_image={coordinator_image}
        />
    )

    return (
        <SearchPage {...props}
            baseApiUrl="/rest/v2/order"
            components={{
                Tr: ({ childProps, ...innerProps }) => (
                    <Table.Tr
                        {...innerProps }
                        className={classNames({
                            'cursor-pointer': !!childProps,
                            'bg-blue-50': props?.location?.pathname.startsWith(`/orders/${childProps?.uid}`),
                        })}
                        onClick={childProps?.uid ? () => history.push(`/orders/${childProps.uid}/overview`) : undefined}
                    />
                )
            }}
            head={{
                uid: { className: 'w-24', label: 'ID' },
                deadline: { sortable: true },
                name: { sortable: true },
                customer_name: { label: 'Customer' },
                total: { sortable: true },
            }}
            body={!props.match.isExact ? {
                uid: Span,
                name: Span,
            } : {
                uid: Span,
                stage: OrderStage,
                deadline: Deadline,
                name: Span,
                customer_name: Span,
                total: Span,
                tasks: TasksSummary,
                coordinator: Coordinator,
            }}
        />
    )
}

export default OrderSearchPage
